<template>
  <div>
    <div style="display: none !important">
      <img  src="../assets/img/kol_logo_400.png" width="400" height="400">
    </div>
    <router-view style="height: 100%; overflow: hidden;"></router-view>
    <MPFooter></MPFooter>
  </div>
</template>
<script type="text/javascript">
import { FITFormCard, FITCheckbox, FITSelect, FITTextInput, FITInputTag, FITButton, MPFooter } from '@/components'
import { mapGetters } from 'vuex'
import Cookies from 'js-cookie'
import Vue from 'vue'


export default {
  name: 'H5Container',
  components: {
    FITCheckbox,
    FITSelect,
    FITTextInput,
    FITInputTag,
    FITButton,
    FITFormCard,
    MPFooter
  },
  props: {},
  data() {
    return {

    }
  },
  created() {
    document.title = this.$t('product.list.pageTitle.myShop');
  // console.log('h5: '+token );
    let token = Cookies.get('token');
    if (!token) { // New Customer 
      this.setLocale('zh_hk');
      this.$store.dispatch('Auth/createTmpToken', { shopLink: this.currentRoute.query.link }).then((json)=>{
          this.axios.defaults.headers.common['Authorization'] = json.data.token;
      });
    } else {
      this.loadCartProducts(token);
    }
      // this.$store.dispatch('getExchangeRate');

  },
  computed: {
    currentRoute() {
      return this.$router.currentRoute;
    }
  },
  mounted() {},
  watch: {},
  methods: {
       setLocale(locale) {
      Vue.config.lang = locale;
      this.$cookie.set('locale', locale);
      this.$i18n.locale = Vue.config.lang;
      // console.log("New locale = " + Vue.config.lang + ": language = " + localeStrings[Vue.config.lang])
    },
    loadCartProducts(currentToken) {
      let previousToken = Vue.localStorage.get('cartToken');
      if (previousToken == currentToken) {
        // load cart products
        let cartProducts = JSON.parse(Vue.localStorage.get('cartProducts'));
        this.$store.commit('setShoppingCart', { cartProducts: cartProducts })
      } else {
        //clears cart products
        this.$store.dispatch('clearShoppingCart');
      }

      // console.log('prev' + previousToken);
      // console.log('currentToken' + currentToken);
      Vue.localStorage.set('cartToken', currentToken);

    }
  },
}

</script>
<style type="text/css">
</style>



// WEBPACK FOOTER //
// src/containers/H5Container.vue